/**
 * @summary get a href for the external link.
 * @param link The external link value as string.
 * @returns If external link starts with a url protocol definition then returns the input value
 * else method will prefix https:// to the input value and returns modified link value.
 */
export function getHrefForExternalLink (link: string | null): string | null {
	const httpsPrefix: string = "https://"

	if (!link || !link.trim()) {
		return link
	}

	// This regex matches common URL protocols at the beginning of a string
	const protocolRegex: RegExp = /^[a-z][a-z0-9+.-]*:\/\//i

	if (!protocolRegex.test(link)) {
		// No protocol detected, default to https
		return `${httpsPrefix}${link}`
	}

	return link
}
